<script>
    import { onMount } from 'svelte';
    import Spinner from "./Spinner.svelte";

    export let answers;
    export let description = "";
    export let category;

    let products = [];
    let hasFetched = false;

    onMount(async () => {
        products = await fetchTopProducts();
    });

    async function fetchTopProducts() {
        try {
            const response = await fetch(`${window.digi_configurator_object.rest_url}/configurator/finish/${category}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    answers: answers
                })
            });

            if (response.ok) {
                hasFetched = true;
                return await response.json();
            } else {
                new Error(`${response.status} ${response.statusText}`)
            }
        } catch (e) {
            console.error(e)
        }
    }
</script>

<h2>Uw persoonlijke top 3</h2>
<p>
    {description}
</p>


{#if products.length > 0}
    <div class="dg-products vc_row">
        {#each products as product, key}
            <div class="vc_col-sm-4">
                <div class="dg-product">
                    <strong class="dg-product__number">{key + 1}.</strong>
                    <img src={product.featured_src} alt="" />
                    <div class="dg-product__info">
                        <a class="dg-product__title" href={product.permalink}>
                            <h4>{product.title}</h4>
                        </a>
                        <ul>
                            {#each Object.values(product.attributes) as attribute}
                                <li>
                                    <strong>{@html attribute['label']}</strong>
                                    {@html attribute['value']}
                                </li>
                            {/each}
                        </ul>
                        <div class="product-prices">
                            <p class="product-price">
                                {@html product.price_html},-
                            </p>

                            <p class="product-price no-tax">
                                {product.price_excl},- excl. btw
                            </p>
                        </div>

                        <a class="dg-offerte button" href={product.permalink}>
                            bekijk product
                        </a>
                    </div>
                </div>
            </div>
        {/each}
    </div>
{:else}
    {#if !hasFetched}
        <div class="vc_row loading-parent">
            <Spinner />
        </div>
    {:else}
        <div class="loading-parent">
            <h2>Geen producten gevonden</h2>
        </div>
    {/if}
{/if}

<style lang="scss">
    .loading-parent {
        height: 400px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .dg-products {
        width: 100% !important;
        display: flex;
        flex-wrap: wrap;

        .dg-product {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;

            &__number {
                font-size: 50px;
                font-weight: bold;
                text-align: center;
            }

            &__title {
                height: 100%;
            }

            &__info {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;

                h4 {
                    font-size: 20px;
                    height: 100%;
                    letter-spacing: 0;
                    font-weight: bold;
                    text-transform: initial;
                    font-family: 'Rubik', sans-serif;
                    margin-bottom: 15px;
                    color: #000 !important;
                }

                ul {
                    margin-left: 20px !important;
                    margin-bottom: 15px;
                    li {
                        line-height: 17px !important;
                        font-size: 14px !important;
                    }
                }

                .woocommerce-Price-currencySymbol {
                    display: none;
                }

                .product-price {
                    font-size: 20px;
                    font-weight: 700;
                    color: #2f2f2f;
                    margin-bottom: 0;
                    text-align: left;
                    line-height: 1.5 !important;

                    &.no-tax {
                        font-weight: 400;
                        font-size: 16px;
                        color: #25cb01;
                    }
                }

                a.dg-offerte {
                    margin-top: 15px;
                    background: #25CB01;
                    color: #fff;
                    font-size: 14px;
                    text-transform: initial;
                    letter-spacing: normal;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    &::after {
                        content: '';
                        display: block;
                        background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMC42MjEiIGhlaWdodD0iMTguMjQzIiB2aWV3Qm94PSIwIDAgMTAuNjIxIDE4LjI0MyI+PHBhdGggZD0iTTAsMCw3LDcsMCwxNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMi4xMjEgMi4xMjEpIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjMiLz48L3N2Zz4=");
                        width: 7px;
                        height: 14px;
                        background-size: contain;
                        background-repeat: no-repeat;
                        margin-left: 25px;
                        position: relative;
                        left: 10px;
                    }
                }
            }
        }
    }
</style>
